export const SITE_NAME = 'FlyNodex';
export const SITE_DOMAIN = 'flynodex.com';
export const SITE_URL = 'https://flynodex.com';

export const COMPANY_NAME = 'Nodex Global LLC';
export const COMPANY_EMAIL = 'info@nodexgloballlc.com';
export const ADDRESS_LINE1 = '32 N Gould St.';
export const ADDRESS_LINE2 = 'Sheridan, WY 82801';
export const ADDRESS_COUNTRY = 'United States';

export const SUPPORT_HOURS = 'Every day, 24 hours';

/** Shown at the very top of every page, before anything else */
export const TOP_DISCLOSURE = `${SITE_NAME} is an independent travel agency run by ${COMPANY_NAME}. We are not an airline, hotel or cruise line, and we are not affiliated with or endorsed by any travel provider.`;

/** Shown next to every call button */
export const CALL_NOTE = `Calls are answered by ${SITE_NAME} travel advisors (${COMPANY_NAME}), not by an airline or other travel provider.`;

export const POLICY_UPDATED = 'October 25, 2026';

export const NAV_LINKS = [
  { to: '/#services', label: 'Services' },
  { to: '/#how-it-works', label: 'How It Works' },
  { to: '/#destinations', label: 'Destinations' },
  { to: '/#faq', label: 'FAQ' },
  { to: '/about-us', label: 'About Us' },
  { to: '/contact-us', label: 'Contact' },
];

export const POLICY_LINKS = [
  { to: '/privacy-policy', label: 'Privacy Policy' },
  { to: '/terms-and-conditions', label: 'Terms & Conditions' },
  { to: '/cookie-policy', label: 'Cookie Policy' },
  { to: '/cancellation-refund-policy', label: 'Cancellation & Refund Policy' },
  { to: '/service-fees', label: 'Service Fees' },
  { to: '/disclaimer', label: 'Disclaimer' },
  { to: '/advertiser-disclosure', label: 'Advertiser Disclosure' },
];

export const COMPANY_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/about-us', label: 'About Us' },
  { to: '/contact-us', label: 'Contact Us' },
  { to: '/reservations-help-desk', label: 'Reservations Help Desk' },
  { to: '/#quote', label: 'Request a Quote' },
];
